import {
    CreateEditTrainingProjectFormValues,
    CreateEditTrainingProjectExampleFormValues,
    TrainingProjectTaskType,
    TrainingProjectExampleSourceType,
    TrainingProjectExampleOutputType,
    TrainingProjectOptimizerType,
    TrainingProjectModuleType,
    TrainingProjectAdapterType
} from '../types';

export const trainingProjectFormFields: { [K in keyof Required<CreateEditTrainingProjectFormValues>]: K } = {
    name: 'name',
    systemPrompt: 'systemPrompt',
    referenceModelId: 'referenceModelId',
    teacherModelId: 'teacherModelId',
    judgeModelId: 'judgeModelId',
    taskType: 'taskType',
    optimizerType: 'optimizerType',
    optimizerParams: 'optimizerParams',
    jsonSchemas: 'jsonSchemas',
    fieldDescriptions: 'fieldDescriptions',
    moduleType: 'moduleType',
    adapterType: 'adapterType'
};

export const trainingProjectExampleFormFields: {
    [K in keyof Required<CreateEditTrainingProjectExampleFormValues>]: K;
} = {
    sourceType: 'sourceType',
    sourceValue: 'sourceValue',
    documentName: 'documentName',
    outputType: 'outputType',
    outputValue: 'outputValue',
    explanation: 'explanation'
};

export const trainingProjectTaskTypeValues: { [K in TrainingProjectTaskType]: K } = {
    JsonExtraction: 'JsonExtraction'
};

export const trainingProjectOptimizerTypeValues: { [K in TrainingProjectOptimizerType]: K } = {
    BootstrapFewShot: 'BootstrapFewShot',
    BootstrapFewShotWithRandomSearch: 'BootstrapFewShotWithRandomSearch',
    MIPROv2: 'MIPROv2',
    SIMBA: 'SIMBA',
    GEPA: 'GEPA'
};

export const trainingProjectExampleSourceTypeValues: { [K in TrainingProjectExampleSourceType]: K } = {
    PackageId: 'PackageId',
    Text: 'Text'
};

export const trainingProjectExampleOutputTypeValues: { [K in TrainingProjectExampleOutputType]: K } = {
    Json: 'Json',
    Text: 'Text'
};

export const taskTypeSchemas: { [K in TrainingProjectTaskType]: { [S in string]: string } } = {
    [trainingProjectTaskTypeValues.JsonExtraction]: {
        outputSchema: 'outputSchema'
    }
};

export const taskTypeFieldDescriptions: { [K in TrainingProjectTaskType]: { [S in string]: string } } = {
    [trainingProjectTaskTypeValues.JsonExtraction]: {
        input: 'input',
        output: 'output'
    }
};

export const trainingProjectModuleTypeValues: { [K in TrainingProjectModuleType]: K } = {
    Predict: 'Predict',
    ChainOfThought: 'ChainOfThought'
};

export const trainingProjectAdapterTypeValues: { [K in TrainingProjectAdapterType]: K } = {
    ChatAdapter: 'ChatAdapter',
    JSONAdapter: 'JSONAdapter',
    BAMLAdapter: 'BAMLAdapter',
    TwoStepAdapter: 'TwoStepAdapter'
};
